import api from './apiClient'

export default {
    name: 'userApi',
    create: async (request) => await api.post('manageusers/user', request, false),
    userExist: async (name) => await api.get(`user/exist/${name}`, false),
    isEmailUsed: async (email) => await api.post(`user/email-used`,{email: email}, false),
    validatePassword: async (password) => await api.post(`user/password-valid`,{password: password}),

    async login(request) {
        var result = await api.post('user/login', request, false)
        //[TODO]: set private cookie by using 'set-cookie' response header
        //new chrome 52 security policy does not allow 'set-cookie' for responses from origin with port number
        //will fix after user story will be implemented
        if (process.env.NODE_ENV === 'development') {
            if (result && result.AccessToken) {
                document.cookie = "CmsOnTestApplication=" + result.AccessToken + ";max-age=86400; path=/; secure; samesite=none"
            }
        }
        return result.Claims;
    },
    logoff: async () => await api.post('user/logoff'),

    getClaims: async () => await api.get("user/claims", false),

    createPassword: async (password) => await api.post("user/create-password", { password: password }),
    acceptTermsOfUse: async () => await api.post("user/accept-terms-of-use"),
    getSecurityQuestions: async () => await api.get('user/security-questions'),
    createSecurityAnswers: async (data) => await api.post('user/security-questions', data),

    getSecurityQuestionByUserName: async (request) => await api.get(`manageusers/question-by-username/${request.value}/${request.order}`, false),
    getSecurityQuestionByEmail: async (request) => await api.get(`manageusers/question-by-email/${request.value}/${request.order}`, false),
    restorePassword: async (request) => await api.post('manageusers/restore-password', request, false),
    sendEmailWithUserName: async (request) => await api.post('manageusers/send-username', request, false),

    updatePassword: async (request) => await api.post('user/update-password', request),
    getUserProfile: async () =>  await api.get('user/profile'),
    updateUserProfile: async (request) => await api.put('user/profile', request),

    testBefore: async() => await api.get('user/test-before')
}   